export default __webpack_public_path__ + "static/media/telegram.22b1ecb9.png";